export default __webpack_public_path__ + "static/media/logo.4def73f6.png";